import { HttpClient } from '@angular/common/http';
import { Component, Injectable, OnInit } from '@angular/core';
import { Subject } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root',
})
@Component({
  selector: 'app-categories',
  templateUrl: './categories.component.html',
  styleUrls: ['./categories.component.css']
})
export class CategoriesComponent implements OnInit {

  selectedCategory: any = null;
  categoriesUrl = `${environment.API_URL}/category`;

  public selectedCategoryChange: Subject<any> = new Subject<any>();


  constructor(private http: HttpClient) {
  }

  ngOnInit(): any{
  }

  getAll(): any {
    
    return this.http.get(this.categoriesUrl);
  
  }
  
  setSelected(cat: any): void{
    this.selectedCategory = cat;
    this.selectedCategoryChange.next(cat);
  }
}
